// extracted by css-extract-rspack-plugin
var _1 = "IWfYW";
var _2 = "aPeQr";
var _3 = "W5pCT";
var _4 = "fc_Os";
var _5 = "k1aiH";
var _6 = "PEPgk";
export { _1 as "bodyColor", _2 as "container", _3 as "miniatureContainer", _4 as "spinner", _5 as "textButtonContainer", _6 as "textContainer" }
